<template>
<v-main>
  <v-layout row class="pa-6" justify-center>
    <v-card class="px-5 mx-2 rounded-xl" width="1200">
      <v-card-title>
        Cadastrar Painel da Unidade
      </v-card-title>
      <v-divider />
      <div>
        <v-form ref="form" v-model="valid">
          <v-text-field v-model="nome" label="Nome para identificação" :rules="IdentificacaoRules" required />
          <v-text-field v-model="username" label="Login" :rules="nameRules" required />
          <!-- <v-text-field
      label="E-mail"
      v-model="email"
      :rules="emailRules"
      required
    ></v-text-field> -->
          <v-text-field v-model="senha" autocomplete="new-password" :append-icon="show1 ? 'visibility' : 'visibility_off'" :rules="senhaRules" :type="show1 ? 'text' : 'password'" label="Senha" counter @click:append="show1 = !show1" />

          <v-autocomplete v-model="idLocalEscolhido" item-value="idLocal" item-text="nomeLocal" :hint="!isEditing ? 'Escolha um local' : ''" :items="listaLocais" :readonly="!isEditing" :rules="[(v) => !!v || 'Local obrigatório']" label="Local" persistent-hint />
          <v-layout row class="px-3">
            <v-flex md4>
              <v-radio-group v-model="modoVisualizacao" class="mb-4 pb-1" :rules="[(v) => !!v || 'Campo obrigatório']" hide-details>
                <template v-slot:label>
                  <strong>Quais chamadas você deseja mostrar?</strong>
                </template>
                <v-radio value="recepcao" label="Recepção" />
                <v-radio value="medico" label="Médico" />
                <v-radio value="recepcao-medico" label="Recepção e Médico" />
              </v-radio-group>
            </v-flex>
            <!-- <v-select
      label="Local"
      v-model="idLocalEscolhido"
      item-value="idLocal"
      item-text="nomeLocal"
      :items="listaLocais"
      :rules="[(v) => !!v || 'Adicione um Local !']"
      required
    ></v-select> -->
            <v-flex md4>
              <v-checkbox v-model="isTelevisao" label="Exibir transmissão de canais no painel?" :false-value="0" :true-value="1" required />
            </v-flex>
            <v-flex md4>
              <v-checkbox v-model="checkbox" label="Você Concorda?" :rules="[(v) => !!v || 'Você deve concordar para cadastrar!']" required />
            </v-flex>
          </v-layout>
          <v-alert :value="erroLogin" color="error" icon="warning" outlined>
            Username já existente !!
          </v-alert>

          <v-alert :value="sucessoLogin" color="success" icon="check_circle" outlined>
            Painel cadastrado com sucesso !!
          </v-alert>

        </v-form>
      </div>
      <v-card-actions>
        <v-spacer />

        <v-btn dark rounded :class="{ red: !valid, green: valid }" @click="submit">
          cadastrar
        </v-btn>
        <v-btn rounded outlined to="/listaPaineisUnidade">
          <v-icon left>
            keyboard_backspace
          </v-icon>
          voltar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'CadastrarAtendenteUnidade',
  components: {
    // HelloWorld
  },
  data () {
    return {
      show1: false,
      tipo: 6,
      valid: false,
      isTelevisao: false,
      modoVisualizacao: '',
      isEditing: true,
      erroLogin: false,
      sucessoLogin: false,
      listaLocais: [],
      senha: '',
      username: '',
      nome: '',
      idLocalEscolhido: '',
      respostaServidor: '',
      idUnidadeEscolhida: '',
      listaUnidades: [],
      rules: {
        min: v => v.length >= 8 || 'minimo 8 caracteres'
      },
      senhaRules: [
        (v) => v && v.length > 5 || 'senha deve ter 6 ou mais caracteres'
      ],
      IdentificacaoRules: [
        (v) => !!v || 'Identificação obrigatório'
      ],
      nameRules: [
        (v) => !!v || 'Login obrigatório',
        (v) => v && v.length > 7 || 'Este campo deve ter mais de 7 caracteres '
      ],
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: true

    }
  },
  created () {
    console.log('created...')
  },
  mounted () {
    console.log('em mounted lista unid...')
    // console.log(this.user);
    this.clear()
    this.user = this.$store.getters.usuario
    this.retornarLocais()
  },
  methods: {
    // isDisabled(){
    //   return this.nome !== '' && this.senha !== '' && this.idUnidadeEscolhida !== '';
    // },
    clear () {
      this.$refs.form.reset()
    },

    submit () {
      if (this.$refs.form.validate()) {
        this.sucessoLogin = false
        this.erroLogin = false
        if (this.isTelevisao == undefined) {
          this.isTelevisao = 0
        }
        administradorUnidadeService.administradorUnidade
          .cadastrarFuncionario(this.idLocalEscolhido, this.username, this.senha, this.tipo, this.nome, this.isTelevisao, this.modoVisualizacao)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)
            if (rsp.data == 'usernameExistente') {
              this.erroLogin = true
            }
            if (rsp.data == true) {
              this.sucessoLogin = true
              this.clear()
            }
            // console.log(this.listaChamadas);
            // this.servicoTeste = rsp.data
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    limpar () {
      this.senha = ''
      this.nome = ''
      this.idUnidadeEscolhida = ''
      // this.checkbox = null
      // this.$validator.reset()
    },

    retornarLocais () {
      console.log('retornar locais visor...')
      administradorUnidadeService.administradorUnidade
        .retornarLocais()
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data)
          this.listaLocais = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }

  }
}
</script>
